import './search-page.styl';

import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import Spinner from '../../components/spinner/Spinner.react';
import Pagination from '../../components/pagination/Pagination';
import {searchInGoogle, inputSearch, translateQuery, onSelectSource} from '../../../common/search/actions';
import SearchResults from '../../components/search-results/SearchResults';
import {FormattedMessage} from 'react-intl';

class SearchPage extends React.Component {
  static propTypes = {
    searchInGoogle: React.PropTypes.func.isRequired,
    inputSearch: React.PropTypes.func.isRequired,
    translateQuery: React.PropTypes.func.isRequired,
    onSelectSource: React.PropTypes.func.isRequired,

    searchQueryTranslated: React.PropTypes.string,

    results: React.PropTypes.object,
    searchInformation: React.PropTypes.object,
    details: React.PropTypes.object,
    searchQuery: React.PropTypes.string,
    pending: React.PropTypes.bool,
    location: React.PropTypes.object.isRequired,
    useragent: React.PropTypes.object.isRequired
  };

  static contextTypes = {
    serverFetchPromises: React.PropTypes.array
  };

  componentWillMount() {
    const {
      onSelectSource,
      searchInGoogle,
      translateQuery,
      inputSearch,
      location,
      searchQueryTranslated
    } = this.props;
    const { serverFetchPromises } = this.context;

    onSelectSource(location.query.searchSource);
    inputSearch(location.query.q);
    if (serverFetchPromises) {
      serverFetchPromises.push(translateQuery({q: location.query.q, targetLanguage: location.query.lr}));
      serverFetchPromises.push(searchInGoogle(location.query));
      return serverFetchPromises;
    }

    return false;
  }

  render() {
    const {results, searchInformation, location, details, translateResults, pending} = this.props;

    return (
      <div
        className={classNames({
          'search-page': true,
          'search-page_pending': pending
        })}
      >
        {!!details && !!details.errors &&
          <div className="search-page__errors">
            {details.errors
              ? details.errors.map((error, index) =>
                <div className="search-page__error" key={index}>{error.message}</div>
                )
              : !!details.message && <div className="search-page__error">{details.message}</div>
            }
          </div>
        }
        {pending && false &&
          <div className="search-page__spinner">
            <Spinner size="xxl" />
          </div>
        }
        <div className="search-page__items">
          {searchInformation.totalResults && searchInformation.totalResults > 0
            ? <SearchResults
                results={results}
                translateResults={translateResults}
                useragent={this.props.useragent}
                locale={this.props.currentLocale}
              />
            : (!pending && <div className="search-page__empty"><FormattedMessage id="search.results.empty" /></div>)
          }
        </div>
        {!!searchInformation.totalResults &&
          <div className="search-page__info">
            {!pending && searchInformation.totalResults > 0 &&
              <div className="search-page__pagination">
              <Pagination location={location} />
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

export default connect(state => ({
  results: state.search.results,
  searchQuery: state.search.searchQuery,
  searchQueryTranslated: state.search.searchQueryTranslated,
  pending: state.search.pending,
  translateResults: state.search.translateResults,
  searchInformation: state.search.searchInformation,
  details: state.search.details,
  useragent: state.device.useragent,
  currentLocale: state.intl.currentLocale
}), {searchInGoogle, inputSearch, translateQuery, onSelectSource})(SearchPage);



// WEBPACK FOOTER //
// ./src/client/pages/search/SearchPage.js